<template>
  <div class="page-content productos-page">
    <div class="productos-wrapper">
      <div class="productos-card">
        <!-- Header -->
        <header class="productos-header">
          <div>
            <p class="productos-title">Gestión de Productos</p>
            <p class="productos-subtitle">
              Administra los productos principales, complementos y su categorización.
            </p>
          </div>

          <div class="productos-header-right">
            <!-- Buscador -->
            <div class="productos-search">
              <span class="productos-search-icon">
                <!-- icono simple "lupa" -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  class="productos-search-icon-svg"
                  aria-hidden="true"
                >
                  <path
                    d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79L19 20.49 20.49 19 15.5 14zm-6 0C8.01 14 6 11.99 6 9.5S8.01 5 10.5 5 15 7.01 15 9.5 12.99 14 10.5 14z"
                  />
                </svg>
              </span>
              <input
                v-model="terminoBusqueda"
                type="text"
                class="productos-search-input"
                placeholder="Buscar producto, SKU, categoría…"
              />
            </div>

            <!-- Acciones -->
            <div class="productos-actions">
              <!-- + Agregar Producto -->
              <button
                v-if="$canView && $canView('superadministrador', 'administrador')"
                type="button"
                class="productos-btn productos-btn--primary"
                @click="mostrarFormulario = true"
              >
                + Agregar producto
              </button>

              <!-- + Categorías -->
              <button
                v-if="$canView && $canView('superadministrador', 'administrador')"
                type="button"
                class="productos-btn productos-btn--secondary"
                @click="mostrarGestionCategorias = true"
              >
                + Categorías
              </button>

              <!-- Filtrar por Categoría -->
              <button
                v-if="$canView && $canView('superadministrador', 'administrador')"
                type="button"
                class="productos-btn productos-btn--ghost"
                @click="mostrarFiltro = true"
              >
                Filtrar por categoría
              </button>
            </div>
          </div>
        </header>

        <!-- Tabla de productos -->
        <section class="productos-table-wrapper">
          <TablaProductos
            :productos="productosFiltrados"
            @editar="editarProducto"
            @asignar="asignarComplementos"
          />
        </section>
      </div>
    </div>

    <!-- Formularios / Modales -->
    <FormularioProducto
      v-if="mostrarFormulario"
      :producto="productoSeleccionado"
      @cerrar="cerrarFormulario"
      @guardado="productoGuardado"
    />

    <AsignarComplementos
      v-if="mostrarComplementos"
      :productoId="productoComplementarId"
      @cerrar="mostrarComplementos = false"
    />

    <GestionCategorias
      v-if="mostrarGestionCategorias"
      @cerrar="mostrarGestionCategorias = false"
      @finalizarCreacionCategoria="mostrarGestionCategorias = false"
    />

    <FiltroCategorias
      v-if="mostrarFiltro"
      :categorias="categoriasDisponibles"
      :seleccionadas="categoriasSeleccionadas"
      @cerrar="mostrarFiltro = false"
      @aplicar="aplicarFiltro"
    />
  </div>
</template>

<script>
import axios from 'axios';
import TablaProductos from '@/components/almacen/productos/TablaProductos.vue';
import FormularioProducto from '@/components/almacen/productos/FormularioProducto.vue';
import AsignarComplementos from '@/components/almacen/productos/AsignarComplementos.vue';
import GestionCategorias from '@/components/almacen/categorias/GestionCategorias.vue';
import FiltroCategorias from '@/components/almacen/categorias/FiltroCategorias.vue';

export default {
  name: 'DashboardProductos',
  components: {
    TablaProductos,
    FormularioProducto,
    AsignarComplementos,
    GestionCategorias,
    FiltroCategorias,
  },
  data() {
    return {
      productos: [],
      mostrarFormulario: false,
      productoSeleccionado: null,
      mostrarComplementos: false,
      productoComplementarId: null,
      mostrarGestionCategorias: false,
      mostrarFiltro: false,
      categoriasDisponibles: [],
      categoriasSeleccionadas: [],
      terminoBusqueda: '',
    };
  },
  computed: {
    productosFiltrados() {
      const lista = this.productos || [];
      const query = (this.terminoBusqueda || '').toLowerCase().trim();

      if (!query) {
        return lista;
      }

      const camposRelevantes = [
        'nombre',
        'sku',
        'codigo',
        'clave',
        'categoria',
        'categoria_nombre',
        'tipo',
        'descripcion',
      ];

      return lista.filter((producto) => {
        return camposRelevantes.some((campo) => {
          const valor = producto && producto[campo] != null
            ? String(producto[campo]).toLowerCase()
            : '';
          return valor.includes(query);
        });
      });
    },
  },
  mounted() {
    this.cargarProductos();
  },
  methods: {
    async cargarProductos() {
      try {
        const res = await axios.get('/api/almacen/productos/listar');
        this.productos = res.data;
      } catch (error) {
        console.error('Error al cargar productos', error);
        this.$toast?.error('No se pudieron cargar los productos.');
      }
    },

    async aplicarFiltro(categorias) {
      this.categoriasSeleccionadas = categorias;
      this.mostrarFiltro = false;

      try {
        const res = await axios.post('/api/almacen/productos/filtrar', {
          categorias: this.categoriasSeleccionadas,
        });
        this.productos = res.data;
      } catch (e) {
        console.error('Error al filtrar productos', e);
        this.$toast?.error('No se pudo aplicar el filtro.');
      }
    },
    cerrarFormulario() {
      this.mostrarFormulario = false;
      this.productoSeleccionado = null;
    },
    editarProducto(producto) {
      this.productoSeleccionado = producto;
      this.mostrarFormulario = true;
    },
    productoGuardado(idProducto, esPrincipal) {
      this.cerrarFormulario();
      this.cargarProductos();
      if (esPrincipal) {
        this.productoComplementarId = idProducto;
        this.mostrarComplementos = true;
      }
    },
    asignarComplementos(idProducto) {
      this.productoComplementarId = idProducto;
      this.mostrarComplementos = true;
    },
  },
};
</script>

<style scoped lang="scss">
.productos-page {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1.5rem 1rem;
}

.productos-wrapper {
  width: 100%;
  max-width: 1120px;
}

.productos-card {
  border-radius: 1.8rem;
  padding: 1.5rem 1.4rem 1.4rem;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.35),
      rgba(15, 23, 42, 0.96)
    );
  backdrop-filter: blur(24px);
  border: 1px solid rgba(148, 163, 184, 0.6);
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.9),
    0 0 0 1px rgba(15, 23, 42, 0.85);
}

.productos-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1.1rem;
}

.productos-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #e5e7eb;
}

.productos-subtitle {
  font-size: 0.82rem;
  color: #94a3b8;
}

/* Lado derecho del header: buscador + acciones */
.productos-header-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.45rem;
}

/* Buscador */
.productos-search {
  position: relative;
  width: 240px;
  max-width: 100%;
}

.productos-search-icon {
  position: absolute;
  inset-y: 0;
  left: 0.65rem;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.productos-search-icon-svg {
  width: 14px;
  height: 14px;
  fill: #64748b;
}

.productos-search-input {
  width: 100%;
  padding: 0.35rem 0.75rem 0.35rem 2rem;
  font-size: 0.82rem;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.75);
  background: rgba(15, 23, 42, 0.96);
  color: #e5e7eb;
  outline: none;
  transition:
    border-color 0.16s ease,
    box-shadow 0.16s ease,
    background 0.16s ease;
}

.productos-search-input::placeholder {
  color: #64748b;
}

.productos-search-input:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.75);
  background: rgba(15, 23, 42, 0.98);
}

/* Botonera */
.productos-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.productos-btn {
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
  font-size: 0.8rem;
  border: 1px solid transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    box-shadow 0.16s ease,
    transform 0.1s ease;
}

/* Primario: verde "acción principal" */
.productos-btn--primary {
  background: linear-gradient(
    135deg,
    rgba(34, 197, 94, 0.96),
    rgba(22, 163, 74, 0.96)
  );
  border-color: rgba(22, 163, 74, 1);
  color: #ecfdf5;
  box-shadow: 0 10px 30px rgba(22, 163, 74, 0.55);
}

.productos-btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 36px rgba(22, 163, 74, 0.75);
}

/* Secundario: azul */
.productos-btn--secondary {
  background: linear-gradient(
    135deg,
    rgba(59, 130, 246, 0.96),
    rgba(37, 99, 235, 0.96)
  );
  border-color: rgba(37, 99, 235, 1);
  color: #eff6ff;
  box-shadow: 0 10px 30px rgba(37, 99, 235, 0.55);
}

.productos-btn--secondary:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 36px rgba(37, 99, 235, 0.75);
}

/* Ghost / neutro */
.productos-btn--ghost {
  background: rgba(15, 23, 42, 0.9);
  border-color: rgba(148, 163, 184, 0.7);
  color: #e5e7eb;
}

.productos-btn--ghost:hover {
  background: rgba(15, 23, 42, 0.98);
  border-color: rgba(148, 163, 184, 0.95);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.9);
}

/* Contenedor tabla */
.productos-table-wrapper {
  margin-top: 0.6rem;
  border-radius: 1.25rem;
  border: 1px solid rgba(148, 163, 184, 0.5);
  background: rgba(15, 23, 42, 0.92);
  padding: 0.7rem 0.7rem 0.6rem;
  min-height: 140px;
}

/* Responsive */
@media (max-width: 768px) {
  .productos-card {
    padding: 1.2rem 1rem 1.1rem;
  }

  .productos-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .productos-header-right {
    width: 100%;
    align-items: stretch;
  }

  .productos-search {
    width: 100%;
  }

  .productos-actions {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
